module.exports = __webpack_public_path__ + "img/trees_3.dfd13c43.png";